import { JsonObject, JsonProperty } from "json2typescript";
import { SearchResults } from "../searchResults";
import { Event } from "./event";

@JsonObject('EventSearchResults')
export class EventSearchResults extends SearchResults {
    @JsonProperty('results', [Event])
    results: Event[] = [];
}